import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Reference, Property, Name, Output } from '@components/Reference';
import Sandbox from '@components/Sandbox';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "z-index"
    }}>{`Z-Index`}</h1>
    <p>{`Allows you to change an element’s z-order.`}</p>
    <h2 {...{
      "id": "class-reference"
    }}>{`Class Reference`}</h2>
    <Reference mdxType="Reference">
    <Property mdxType="Property">
        <Name mdxType="Name">.z-0</Name>
        <Output mdxType="Output">z-index: 0;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.z-10</Name>
        <Output mdxType="Output">z-index: 10;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.z-20</Name>
        <Output mdxType="Output">z-index: 20;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.z-30</Name>
        <Output mdxType="Output">z-index: 30;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.z-40</Name>
        <Output mdxType="Output">z-index: 40;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.z-50</Name>
        <Output mdxType="Output">z-index: 50;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.z-60</Name>
        <Output mdxType="Output">z-index: 60;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.z-70</Name>
        <Output mdxType="Output">z-index: 70;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.z-80</Name>
        <Output mdxType="Output">z-index: 80;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.z-90</Name>
        <Output mdxType="Output">z-index: 90;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.z-100</Name>
        <Output mdxType="Output">z-index: 100;</Output>
    </Property>
    </Reference>
    <h2 {...{
      "id": "example"
    }}>{`Example`}</h2>
    <Sandbox mdxType="Sandbox">
    <Sandbox.Preview>
        <div className="p-relative" style={{
          "height": "330px"
        }}>
            <div className="w-10p bg-tertiary-300 ba bc-tertiary-700 h-14 p-absolute c-black fs-caption ta-center z-0" style={{
            "top": "10px",
            "left": "10px"
          }}>z-index:0</div>
            <div className="w-10p bg-tertiary-300 ba bc-tertiary-700 h-14 p-absolute c-black fs-caption ta-center z-10" style={{
            "top": "35px",
            "left": "35px"
          }}>z-index:10</div>
            <div className="w-10p bg-tertiary-300 ba bc-tertiary-700 h-14 p-absolute c-black fs-caption ta-center z-20" style={{
            "top": "60px",
            "left": "60px"
          }}>z-index:20</div>
            <div className="w-10p bg-tertiary-300 ba bc-tertiary-700 h-14 p-absolute c-black fs-caption ta-center z-30" style={{
            "top": "85px",
            "left": "85px"
          }}>z-index:30</div>
            <div className="w-10p bg-tertiary-300 ba bc-tertiary-700 h-14 p-absolute c-black fs-caption ta-center z-40" style={{
            "top": "110px",
            "left": "110px"
          }}>z-index:40</div>
            <div className="w-10p bg-tertiary-300 ba bc-tertiary-700 h-14 p-absolute c-black fs-caption ta-center z-50" style={{
            "top": "135px",
            "left": "135px"
          }}>z-index:50</div>
            <div className="w-10p bg-tertiary-300 ba bc-tertiary-700 h-14 p-absolute c-black fs-caption ta-center z-60" style={{
            "top": "160px",
            "left": "160px"
          }}>z-index:60</div>
            <div className="w-10p bg-tertiary-300 ba bc-tertiary-700 h-14 p-absolute c-black fs-caption ta-center z-70" style={{
            "top": "185px",
            "left": "185px"
          }}>z-index:70</div>
            <div className="w-10p bg-tertiary-300 ba bc-tertiary-700 h-14 p-absolute c-black fs-caption ta-center z-80" style={{
            "top": "210px",
            "left": "210px"
          }}>z-index:80</div>
            <div className="w-10p bg-tertiary-300 ba bc-tertiary-700 h-14 p-absolute c-black fs-caption ta-center z-90" style={{
            "top": "235px",
            "left": "235px"
          }}>z-index:90</div>
            <div className="w-10p bg-tertiary-300 ba bc-tertiary-700 h-14 p-absolute c-black fs-caption ta-center z-100" style={{
            "top": "260px",
            "left": "260px"
          }}>z-index:100</div>
        </div>
    </Sandbox.Preview>
    <Sandbox.Code>
        <div className="z-0">...</div>
        <div className="z-10">...</div>
        <div className="z-20">...</div>
        ...
        <div className="z-100">...</div>
        
    </Sandbox.Code>
    </Sandbox>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      